import React from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Button, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { isNull, isArray, isEmpty, includes } from 'lodash';

import { Modal } from '~/components';

import { t, number } from '~/helpers';
import api from '~/services/api';

import { Form, FormGPP, Tabela, ModalGPP } from './components';
import operator from './operator';
import * as S from './styles';

import {
  ADM,
  GFE,
  FRENTISTA,
  GPP,
  GPPE,
  GPPEM
} from '~/constants/perfil';

/**
 * LEGENDA * 
 * (1) Tur * no aberto, (2) Turno fechado, (3) Transferência de turno.
 * (4) Turno ABERTO aguardando confirmação do gestor.
 * (5) Turno FECHADO aguardando confirmação do gestor.
 */

export default function OperacaoTurno() {
  const [load, setLoad] = React.useState(false);
  const [shift, setShift] = React.useState(null);
  const [tanks, setTanks] = React.useState([]);
  const [opening, setOpening] = React.useState(operator);
  const [closure, setClosure] = React.useState(operator);
  const [posto, setPosto] = React.useState(0);
  const [transfer, setTransfer] = React.useState({});
  const [tabelas, setTabelas] = React.useState({});
  const [bicos, setBicos] = React.useState([]);
  const [estoques, setEstoques] = React.useState([]);

  const { profile } = useSelector((state) => state.user);

  const [pocoTurnoTerminal, setPocoTurnoTerminal] = React.useState(null);

  const modalRef = React.useRef(null);

  const modalGPPRef = React.useRef(null);

  // Check block buttons
  const isBlock = React.useMemo(() => {

    // if (load) return true;
    // if (isNull(shift)) return true;
    // if ((pocoTurnoTerminal) && (pocoTurnoTerminal === 'S')) {
    //   if (includes([4, 5], shift)) return false;
    //   return true;
    // }

    switch (Number(profile.perfcodigo)) {
      case ADM:
      case GFE:
      case GPPE:
      case GPPEM:
        return true
        break;
      case FRENTISTA:
        if (load) return true;
        if (isNull(shift)) return true;
        if ((pocoTurnoTerminal) && (pocoTurnoTerminal === 'S')) {
          if (includes([1, 2, 3], shift)) return false;
          return true;
        } else {
          return true;
        }
        break;
      case GPP:
        if (load) return true;
        if (isNull(shift)) return true;
        if (includes([4, 5], shift)) return false;
        return true;
        break;
      default:
        return true;
    }



  }, [load, shift, pocoTurnoTerminal]);

  // const isBlock = React.useMemo(() => Boolean(load || isNull(shift)), [
  //   load,
  //   shift,
  // ]);



  // Label button turn
  const labelButton = React.useMemo(() => {
    if ((pocoTurnoTerminal) && (pocoTurnoTerminal === 'N') && (shift === 2)) return 'ABRIR TURNO';
    if ((pocoTurnoTerminal) && (pocoTurnoTerminal === 'N') && (shift === 3)) return t('s.operacao.turno.transferir');
    if (shift === 4) return 'CONFIRMAR TURNO';
    if (shift === 5) return 'CONFIRMAR TURNO';
    if ((pocoTurnoTerminal) && (pocoTurnoTerminal === 'N')) return 'FECHAR TURNO';
    else return 'MODO TERMINAL';
  }, [shift, pocoTurnoTerminal]);

  // Text view
  const textView = React.useMemo(() => {
    if (includes([1, 3], shift)) return 'TURNO ABERTO';
    if (shift === 2) return 'TURNO FECHADO';
    if (shift === 4) return 'Turno ABERTO aguardando confirmação do gestor';
    if (shift === 5) return 'Turno FECHADO aguardando confirmação do gestor';
    return '';
  }, [shift]);

  // Closing column heads
  const cellClosing = React.useMemo(
    () => [
      {
        id: 'idbico',
        label: "Bico Numero"
      },

      {
        id: 'nomeabreviadoproduto',
        label: "Produto"
      },

      {
        id: 'mecanicoinicioturnobico',
        label: "Encerrante Mecânico Inicial",
        align: 'right',
      },
      {
        id: 'bicoencerrante',
        label: "Encerrante Atual",
        align: 'right',
      },
      {
        id: 'diferenca',
        label: "Diferença",
        align: 'right',
      },
    ],
    [t]
  );

  // Stock column heads
  const cellStock = React.useMemo(
    () => [
      {
        id: 'codigotanquefisico',
        label: "Tanque",
      },
      {
        id: 'nomeabreviadoproduto',
        label: "Produto"
      },
      {
        id: 'volmedidoinicioturnotanque',
        label: "Volume Inicial Contabil",
        align: 'right',
      },
      {
        id: 'volrecebidoturnotanque',
        label: "Recebimento Descargas",
        align: 'right',
      },
      // {
      //   id: 'voldrenoturnotanque',
      //   label: t('s.operacao.turno.dreno'),
      //   align: 'right',
      // },
      {
        id: 'volabastturnotanque',
        label: "Abastecimentos",
        align: 'right',
      },
      {
        id: 'volvazturnotanque',
        label: "Vazamentos",
        align: 'right',
      },
      {
        id: 'volintransfturnotanque',
        label: "Recebimento Transferências",
        align: 'right',
      },
      {
        id: 'volouttransfturnotanque',
        label: "Saída Transferências",
        align: 'right',
      },
      // {
      //   id: 'volinbombturnotanque',
      //   label: t('s.operacao.turno.entradabombeamento'),
      //   align: 'right',
      // },
      // {
      //   id: 'voloutbombturnotanque',
      //   label: t('s.operacao.turno.saidabombeamento'),
      //   align: 'right',
      // },
      {
        id: 'volumefinal',
        label: "Volume Final Contabil",
        align: 'right',
      },

      ((shift === 5) ||
        (shift === 2)) &&
      {
        id: 'volmedidofimturnotanque',
        label: "Volume Final Medido",
        align: 'right',
      },

    ],
    [t, shift]
  );

  // Reset vars
  const handleResetVars = React.useCallback(() => {
    setOpening(operator);
    setClosure(operator);
    setBicos([]);
    setEstoques([]);
    setTabelas({});
  }, []);

  // Load tanks
  const handleGetTanks = React.useCallback(async () => {
    const params = { pagesize: 9999 };
    setLoad(true);
    try {
      const { data } = await api.get('postosporusuario', { params });
      setTanks(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }, []);

  // Loading data to fill the tables
  const handleGetDataTable = React.useCallback(async (id, codeTransfer, temporizador = 0) => {
    try {
      const { data } = await api.get(`turnos/${id}/${temporizador}`, {
      });

      setTabelas(data);

      setOpening({
        date: data.datahorainicialturno,
        operator: isNull(data.codigousuarioinicialturno)
          ? ''
          : `${data.codigousuarioinicialturno} - ${data.nomeusuarioinicialturno}`,
        description: data.observacaoinicioturno,
      });

      setClosure({
        date: isNull(data.datahorafinalturno)?'': data.datahorafinalturno,

        operator: isNull(data.codigousuariofinalturno)
          ? ''
          : `${data.codigousuariofinalturno} - ${data.nomeusuariofinalturno}`,

        
         description: isNull(data.observacaofimturno)?'':data.observacaofimturno,
      });

      setBicos(
        data.bicos.map((bico) => ({
          ...bico,
          mecanicoinicioturnobico: number(bico.mecanicoinicioturnobico, 1),
          eletronicofimturnobico: number(bico.eletronicofimturnobico, 1),
          bicoencerrante: number(bico.bicoencerrante, 1),
          diferenca: number(bico.diferenca, 1),
        }))
      );

      setEstoques(
        data.tanques.map((tanque) => ({
          ...tanque,
          volmedidoinicioturnotanque: number(
            tanque.volmedidoinicioturnotanque, 2),
          volrecebidoturnotanque: number(tanque.volrecebidoturnotanque, 2),
          voldrenoturnotanque: number(tanque.voldrenoturnotanque, 2),
          volabastturnotanque: number(tanque.volabastturnotanque, 2),
          volvazturnotanque: number(tanque.volvazturnotanque, 2),
          volintransfturnotanque: number(tanque.volintransfturnotanque, 2),
          volouttransfturnotanque: number(tanque.volouttransfturnotanque, 2),
          volinbombturnotanque: number(tanque.volinbombturnotanque, 2),
          voloutbombturnotanque: number(tanque.voloutbombturnotanque, 2),
          volumefinal: number(tanque.volumefinal, 2),
          volmedidofimturnotanque: number(tanque.volmedidofimturnotanque, 2),
        }))
      );

      if (codeTransfer === 1)
        setShift(3);
      else if (data.aberturaPendente === 'S')
        setShift(4);
      else if (data.fechamentoPendente === 'S')
        setShift(5);
      else
        setShift(isEmpty(data.datahorafinalturno) ? 1 : 2);

      setPocoTurnoTerminal(data.poco_turno_terminal);


    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));

      setShift(2);
      handleResetVars();
    }
  }, []);

  // Change autocomplete
  const handleChangeAutocomplete = React.useCallback(
    (value) => {
      if (isNull(value)) {
        setShift(null);

        setPocoTurnoTerminal(null);

        handleResetVars();
      } else {
        const { poco_codigo, poco_turno_terminal, transfereturnoposto } = value;

        setPocoTurnoTerminal(poco_turno_terminal);

        setPosto(poco_codigo);
        setTransfer(value);
        handleGetDataTable(poco_codigo, transfereturnoposto);
      }
    },
    [posto]
  );

  // Open Modal
  const handleOpenModal = React.useCallback(() => {

    if (profile.glousuariotipo === GPP) {
      modalGPPRef.current.handleOpenModal({ posto: transfer, tabelas, type: shift });
    } else {
      modalRef.current.handleOpenModal({ posto: transfer, tabelas, type: shift });
    }

  }, [tabelas, transfer, shift]);

  // Calback close modal
  const handleCallbackOnCloseModal = React.useCallback(async (values) => {
    const { poco_codigo, transfereturnoposto } = values.posto;

    await handleResetVars();
    await handleGetDataTable(poco_codigo, transfereturnoposto);
  }, []);

  // Initial data
  React.useEffect(() => {
    handleGetTanks();
  }, []);

  // Autoload
  React.useEffect(() => {
    if (posto !== 0) {
      const timeOut = setInterval(() => {
        handleGetDataTable(posto, transfer.transfereturnoposto, 1);
      }, 30000);

      return () => clearInterval(timeOut);
    }
  }, [posto, transfer]);

  return (
    <S.Wrapper>
      <S.WrapperGroupText>
        <S.WrapperHeader>

          <Autocomplete
            options={tanks}
            getOptionLabel={({ poco_descricao }) => poco_descricao}
            style={{ width: 300 }}
            onChange={(e, value) => handleChangeAutocomplete(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Posto"
                variant="outlined"
                size="small"
              />
            )}
          />

          <Typography>{textView}</Typography>
        </S.WrapperHeader>

        <Button
          size="small"
          variant="outlined"
          color="primary"
          disabled={isBlock}
          onClick={handleOpenModal}
        >
          {labelButton}
        </Button>
      </S.WrapperGroupText>

      <S.WrapperInputs>
        <S.WrapperTitle>ABERTURA</S.WrapperTitle>

        <S.WrapperGroupInput>
          <TextField
            disabled
            label="Data/Hora"
            size="small"
            variant="outlined"
            value={opening.date}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            disabled
            label="Operador"
            size="small"
            variant="outlined"
            value={opening.operator}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            disabled
            label="Observação"
            size="small"
            variant="outlined"
            value={opening.description}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </S.WrapperGroupInput>

        <S.WrapperTitle>FECHAMENTO</S.WrapperTitle>

        <S.WrapperGroupInput>
          <TextField
            disabled
            label="Data/Hora"
            size="small"
            variant="outlined"
            value={closure.date}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            disabled
            label="Operador"
            size="small"
            variant="outlined"
            value={closure.operator}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            disabled
            label="Observação"
            size="small"
            variant="outlined"
            value={closure.description}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </S.WrapperGroupInput>
      </S.WrapperInputs>

      <S.WrapperGrid>
        <Tabela
          title="ENCERRANTES DOS BICOS"
          cells={cellClosing}
          data={bicos}
          size="small"
        />

        <Tabela
          title="ESTOQUE CONTABIL DOS TANQUES FÍSICOS"
          cells={cellStock}
          data={estoques}
          size="small"
        />
      </S.WrapperGrid>


      <ModalGPP
        form
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalGPPRef}
        title={labelButton}
        component={profile.glousuariotipo === GPP ? FormGPP : Form}
        onClose={handleCallbackOnCloseModal}
      />

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRef}
        title={labelButton}
        component={profile.glousuariotipo === GPP ? FormGPP : Form}
        onClose={handleCallbackOnCloseModal}
      />

    </S.Wrapper>
  );
}
